import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import CookiesContent from './components/CookiesContent';

export default function CookiesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar forceWhiteBg={true} />
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><i className="ri-loader-4-line animate-spin text-4xl text-emerald-500"></i></div>}>
        <CookiesContent />
      </Suspense>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
